import { Box, Icon, Typography } from '@branch-messenger/willow-ui'
import { FC, SVGProps } from 'react'

import { AdvanceInfoItemContainer } from '../styles'

type AdvanceInfoItemProps = {
  title: string
  value: string
  icon: (props: SVGProps<SVGSVGElement>) => React.JSX.Element
  hide?: boolean
}

export const AdvanceInfoItem: FC<AdvanceInfoItemProps> = ({
  title,
  value,
  icon,
  hide = false,
}) => {
  if (hide) return null
  return (
    <AdvanceInfoItemContainer>
      <Icon Icon={icon} size={6} />
      <Box>
        <Typography $color="textMuted" $size="xs">
          {title}
        </Typography>
        <Typography $size="sm" $bold>
          {value}
        </Typography>
      </Box>
    </AdvanceInfoItemContainer>
  )
}
